import { Component, Input, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Porder } from 'src/app/assabil-sales/models/entities/porder';
import { ProcurementService } from 'src/app/assabil-sales/services/procurement.service';
import { PackingPorderService } from '../../services/packing-porder.service';
import { PorderLine } from 'src/app/assabil-sales/models/entities/porder-line';
import { Pack } from '../../models/entities/pack';
 

@Component({
    selector: 'packing-porder-list-mobile',
    templateUrl: './packing-porder-list-mobile.component.html',
    styleUrls: ['./packing-porder-list-mobile.component.scss']
})

export class PackingPorderListMobileComponent implements OnInit {

  constructor(
    protected procurementService   : ProcurementService,
    protected packingPorderService : PackingPorderService,
    protected toastr               : ToastrService,
    protected location             : Location
    ) {
  }

  porders   : Porder[] = [];
  porder    : Porder;


  //------------------------------------------------------------------------------------------------------------------------
    ngOnInit(){
      let code : string, d1 : Date, d2 : Date;
      let regular : boolean = true;
      let returns : boolean = true; 
      let excludeClosed  : boolean
      this.procurementService.pordersGet(code, d1, d2, regular, returns, excludeClosed).then(result => {
          this.porders = result;
      })
    }
  //------------------------------------------------------------------------------------------------------------------------


  //------------------------------------------------------------------------------------------------------------------------
    selectRow(porder : Porder){
      this.procurementService.porderGet(porder.porderCode).then(result => {
          this.porder = result;
    })
  }
  //---------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------
    packCode  : string = null;
    quantity  : number = null;
    processPack(porderLine : PorderLine){
      let pack : Pack = new Pack();
      pack.packCode = this.packCode
   //   this.packingPorderService.addPackToPorder(this.porder.porderCode, porderLine.product.productCode, this.packCode).then(pack => {
        this.packCode = null;
        this.quantity = null;
        if (! porderLine.packs)  porderLine.packs = [];
        porderLine.packs.push(pack);
    //  })
    }
  //---------------------------------------------------------------------------------------------------------------


  //------------------------------------------------------------------------------------------------------------------------
    close(){
      if (this.porder) {
        this.porder = null;
        return;
      }
      this.location.back();
    }
  //------------------------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------------------------
  selectPorderLine(porderLine : PorderLine){
      for (let tmp of this.porder.porderLines){
        tmp.selected = false;
      }
      porderLine.selected = true;
    }
  //------------------------------------------------------------------------------------------------------------------------
  
}
